import {
  CardOaPrintCheck,
  CardOAPrintTransformer,
  CardOAPrintTransformerMap
} from "@sim/collections/dialogs/collection-export-dialog/types";
import {CardOA, CardOAJoined} from "@atmi/models/cards/card-oa";
import {euroCurrencyFormat} from "@sim/collections/dialogs/collection-export-dialog/routines";

const getEditionFromNotes = (notes: string): string => {
  const edizione = notes.split('\n').filter(n => n.indexOf('Edizione') !== -1)[0];
  if (edizione) return edizione.replace('Edizione:', '').trim();
  return '';
}
/**
 * always print these measures
 * @param MIS
 */
export const defaultMeasurePrint: CardOAPrintTransformer = ({MIS}: CardOAJoined): string => {
  const {MISA, MISL, MISP, MISU} = MIS;
  const H = MISA ? `H:${MISA} ` : '';
  const L = MISL ? `L:${MISL} ` : '';
  const P = MISP ? `P:${MISP} ` : '';
  return `${H}${L}${P}${MISU}.`;
}

const printObjectOfPrimitives = (obj: Record<string, string | number | null | undefined | boolean>): string =>
  Object.entries(obj).filter(([_, v]) => Boolean(v)).map(([k, v]) => `${k}:${v}`).join(' ')
/*the label will be taken by the mapping below this record. just to have the freedom of putting it into a separated tag*/
export const cardOAtoPrintTransformers: CardOAPrintTransformerMap = {
  SGT: (card: CardOAJoined) => card.SGT?.SGTT,
  MIS: defaultMeasurePrint, //always checked true
  MISG: (card: CardOAJoined) => card.MIS?.MISG ? `kg ${card.MIS.MISG}` : '',
  MTC: (card: CardOAJoined) => card.MTC.length ? `${card.MTC.join(' ')}` : '',
  YEAR: (card: CardOAJoined) => card.DT?.[0]?.DTS?.DTSI,
  numeroEsemplare: (card: CardOAJoined) => card.numeroEsemplare || '',
  patina: (card: CardOAJoined) => card.patina || '',
  EDITION: (card: CardOAJoined) => card.benePadre?.operaMadre?.tiratura ? `${card.benePadre.operaMadre.tiratura} esemplari` : getEditionFromNotes(card.note),
  DES: (card: CardOAJoined) => card.DES?.DESO,
  prezzoDiListino: (card: CardOAJoined) => card.prodotto?.prezzoDiListino ? euroCurrencyFormat(`${card.prodotto?.prezzoDiListino}`) : '',
  prezzoDiVendita: (card: CardOAJoined) => card.prodotto?.prezzoDiVendita ? euroCurrencyFormat(`${card.prodotto?.prezzoDiVendita}`) : '',
  operaMadre: ({operaMadre}: CardOAJoined) => operaMadre ? `${(operaMadre.tiratura || 0) + (operaMadre.tiraturaHC || 0) + (operaMadre.tiraturaEA || 0)}` : '',
  baseWeight: (card: CardOAJoined) => card.base?.peso ? `kg ${card.base?.peso}` : '',
  baseMaterial: (card: CardOAJoined) => `${card.base?.materiale.join(' ')}`,
  baseMIS: (card: CardOAJoined) => {
    const {base} = card;
    if (!base) return '';
    const {altezza, larghezza, profondita, dimensioniVarie} = base;
    return `H:${altezza} L:${larghezza} P:${profondita} cm.`; //nella base manca l'unita di misura. per ora ho messo cm
  }
}
/*@TODO rename to labels*/
export const BeneOA_Path_NiceNames: Record<string, string> = {
  SGT: 'Nome',
  YEAR: 'Anno',
  MTC: 'Materiale',
  MIS: 'Misure',
  baseMaterial: 'Materiale Base',
  baseMIS: 'Misure Base',
  baseWeight: 'Peso Base',
  EDITION: 'Edizione',
  MISG: 'Peso',
  DES: 'Descrizione',
  patina: 'Patina',
  prezzoDiListino: 'Valore Assicurativo',
  prezzoDiVendita: 'Prezzo Pub.Imp.',
  numeroEsemplare: 'Numero esemplare',
  operaMadre: 'Opera Madre',
};
export const beneOaSwitchesDefaultValues: Partial<CardOaPrintCheck> = {
  SGT: true,
  YEAR: true,
  MTC: true,
  MIS: true,
  EDITION: true,
  MISG: true,
  //second step
  ISR: false,
  fornitore: false,
  fontiBib: false,
  fontiArc: false,
  allegati: false,
  movimenti: false
};

/*prop names print order for model showRoom*/
export const showRoomPropPrintOrder: Record<string, number> = {
  SGT: 0,
  YEAR: 1,
  MTC: 2,
  MIS: 3,
  MISG: 4,
  baseMaterial: 5,
  baseMIS: 6,
  baseWeight: 7,
  EDITION: 8,
  DES: 9,
  patina: 10,
  prezzoDiListino: 11,
  prezzoDiVendita: 12,
  numeroEsemplare: 13,
  operaMadre: 14
};

export const BeneOA_Path_NiceNames_B: Record<string, string> = {
  ISR: 'iscrizioni',
  fornitore: 'fornitore',
  fontiBib: 'Fonti Bibliografiche',
  fontiArc: 'Fonti Archivistiche',
  allegati: 'Allegati',
  movimenti: 'Movimenti'
};

export const sortByOrder = <T extends { ordine: number }>(a: T, b: T) => a.ordine - b.ordine;
